module.exports = __webpack_public_path__ + "img/Group 13.8d43bf5.svg";